/**
 * Escape a value for CSV output. Wraps in double quotes when the value
 * contains commas, quotes, or line breaks.
 */
export function escapeCsvValue(value) {
  const raw = value === null || value === undefined ? '' : String(value);
  if (!/[",\n\r]/.test(raw)) {
    return raw;
  }
  const escaped = raw.replace(/"/g, '""');
  return `"${escaped}"`;
}

/**
 * Parse CSV text into rows of field values (RFC 4180-style).
 * Handles quoted fields with commas, escaped quotes, and newlines inside quotes.
 */
export function parseCSVRows(text) {
  const rows = [];
  let currentRow = [];
  let currentField = '';
  let inQuotes = false;

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (inQuotes) {
      if (char === '"') {
        if (nextChar === '"') {
          currentField += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        currentField += char;
      }
    } else if (char === '"') {
      inQuotes = true;
    } else if (char === ',') {
      currentRow.push(currentField);
      currentField = '';
    } else if (char === '\n') {
      currentRow.push(currentField);
      currentField = '';
      rows.push(currentRow);
      currentRow = [];
    } else if (char !== '\r') {
      currentField += char;
    }
  }

  if (currentField.length > 0 || currentRow.length > 0) {
    currentRow.push(currentField);
    rows.push(currentRow);
  }

  return rows.map(row => row.map(cell => cell.trim()));
}

/**
 * Strip UTF-8 BOM and parse CSV into header + data rows.
 * Skips empty rows and rows whose first cell is a # comment.
 */
export function parseCSVText(text) {
  let normalized = text;
  if (normalized.charCodeAt(0) === 0xfeff) {
    normalized = normalized.slice(1);
  }

  const allRows = parseCSVRows(normalized);
  const rows = allRows.filter(row => {
    const firstCell = (row[0] || '').trim();
    if (!row.some(cell => cell.trim())) return false;
    if (firstCell.startsWith('#')) return false;
    return true;
  });

  if (rows.length === 0) {
    return { headers: [], dataRows: [] };
  }

  const headers = rows[0].map(header => header.replace(/^\uFEFF/, '').trim());
  const dataRows = rows.slice(1);

  return { headers, dataRows };
}
